import gsap from "gsap";

export default class MenuItem {
    constructor(el) {
        this.DOM = { el: el };
        this.targetSelector = this.DOM.el.dataset.targetSelector;
        this.backdrop = this.DOM.el.dataset.menuItemBackdrop || null;
        this.DOM.targets = Array.from(document.querySelectorAll(this.targetSelector));
        this.isOpen = this.DOM.el.classList.contains('is-open');
        this.itemTimeout = null;
        this.backdropTimeout = null;
        this.isMobile = true;

        this.menuItems = Array.from(this.DOM.el.querySelectorAll(this.DOM.el.dataset.menuItemItems));

        this.initEvents();
    }

    initEvents() {
        const open = () => {
            if (!this.isOpen) {
                clearTimeout(this.itemTimeout);
                clearTimeout(this.backdropTimeout);
                this.open();
            }
        }

        const close = () => {
            if (this.isOpen) {
                clearTimeout(this.itemTimeout);
                clearTimeout(this.backdropTimeout);
                this.close();
            }
        }

        if (this.DOM.targets !== null) {
            this.DOM.targets.forEach(target => {
                const targetAction = target.dataset.menuItemAction;
                target.addEventListener('click', (e) => {
                    e.preventDefault();

                    if (targetAction == 'open') {
                        open();
                    }

                    if (targetAction == 'close') {
                        close();
                    }
                });
            });

            /* Listener for breakpoint change */
            const matchMedia = window.matchMedia(`(min-width: 1280px)`);

            if (matchMedia.matches) {
                this.isMobile = false;
                this.DOM.targets.forEach(target => {
                    target.parentElement.addEventListener('mouseenter', open);
                    target.parentElement.addEventListener('mouseleave', close);
                });
            } else {
                this.DOM.targets.forEach(target => {
                    this.isMobile = true;
                    target.parentElement.removeEventListener('mouseenter', open);
                    target.parentElement.removeEventListener('mouseleave', close);
                });
            }

            matchMedia.addListener((e) => {
                if (e.target.matches) {
                    this.isMobile = false;
                    this.DOM.targets.forEach(target => {
                        target.parentElement.addEventListener('mouseenter', open);
                        target.parentElement.addEventListener('mouseleave', close);
                    });
                } else {
                    this.isMobile = true;
                    this.DOM.targets.forEach(target => {
                        target.parentElement.removeEventListener('mouseenter', open);
                        target.parentElement.removeEventListener('mouseleave', close);
                    });
                }
            });
        }
    }

    open() {
        this.DOM.el.classList.add('is-visible');
        this.DOM.el.clientHeight;
        this.itemTimeout = setTimeout(() => {
            this.DOM.el.classList.add('is-open');
        }, this.backdrop && !this.isMobile ? 150 : 0);
        this.isOpen = true;

        if (this.isMobile) {
            gsap.set(this.menuItems, { opacity: 0, x: -100, duration: 0.5, ease: "circ.inOut" });
            gsap.to(this.menuItems, { x: 0, stagger: 0.05, duration: 0.5, ease: "circ.inOut" });
            gsap.to(this.menuItems, { opacity: 1, delay: 0.1, stagger: 0.05, duration: 0.5, ease: "circ.inOut" });
        }

        if (this.backdrop) {
            const backdrop = document.querySelector(this.backdrop);

            backdrop.classList.add('is-visible');
            backdrop.clientHeight;
            backdrop.classList.add('is-open');
        }
    }

    close() {
        this.DOM.el.classList.remove('is-open');
        this.itemTimeout = setTimeout(() => {
            this.DOM.el.classList.remove('is-visible');
        }, this.isMobile ? 450 : 300);
        this.isOpen = false;

        if (this.backdrop) {
            const backdrop = document.querySelector(this.backdrop);

            this.backdropTimeout = setTimeout(() => {
                backdrop.classList.remove('is-open');
                this.backdropTimeout = setTimeout(() => {
                    backdrop.classList.remove('is-visible');
                }, 300);
            }, this.isMobile ? 150 : 0);
        }
    }
}

const menuItemNodes = Array.from(document.querySelectorAll('[data-menu-item]'));
if (menuItemNodes !== null) {
    menuItemNodes.forEach((node) => { new MenuItem(node); });
}
